export enum PaymentScheduleType {
  MONTHLY_PAYMENTS = "MONTHLY_PAYMENTS",
  QUARTERLY_PAYMENTS = "QUARTERLY_PAYMENTS",
  PAYMENT_AT_THE_END = "PAYMENT_AT_THE_END",
}
